import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { DevKeyForm } from './DevKeyForm'
import { DevKeyDetails } from './DevKeyDetails'

export const DevKeyContainer = props => {
  let content = props.organization.hasAccountDevKey ? (
    <DevKeyDetails organization={props.organization} />
  ) : (
    <DevKeyForm
      organization={props.organization}
      setOrganization={props.setOrganization}
      toggle={props.toggle}
    />
  )
  return <Fragment>{content}</Fragment>
}

DevKeyContainer.propTypes = {
  organization: PropTypes.object.isRequired,
  setOrganization: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
}
